import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import * as $3Dmol from '3dmol/build/3Dmol.js';
import { FullscreenOutlined } from '@ant-design/icons'
import { elementsList } from '@/config/const';
import { randomId } from '@/config/func';
import { Md5 } from 'md5-typescript';
import ElementInfo from '@/Components/ElementInfo/infoModal';
import { getallAtomsCate } from '@/config/func';
import { Tabs, Image } from 'antd';

const Component = (props: any) => {
  const {
    filePath,
    width,
    height,
    bgColor,
    setAtomsInfos,
    disLenged,
    pngImg,
    refresh,
  } = props;
  const [allAtomInfos, setAllAtomInfos] = useState<any>({});
  const [curElementInfo, setCurElementInfo] = useState<any>({});
  const [elementInfoStatus, setElementInfoStatus] = useState(false);
  const [numeratorInfo, setNumeratorInfo] = useState<any>(null); //分子信息
  const [randomIds, setrandomIds] = useState<any>('');
  const [showType, setShowType] = useState('3d');
  const [showImg, setShowImg] = useState<any>(null);

  const tabsItem = [
    {
      key: '3d',
      label: '分子空间结构',
      children: <div className="mol3d" id={`d${randomIds}`}></div>,
    },
    {
      key: '2d',
      label: '分子图',
      children: <Image src={pngImg} width={width} height={height} />, 
    } 
  ]

  const showControlBar = () => {
    return (
      <ul className='showControl'>
        <li className={`${showType === '3d' ? 'active' : ''}`}
          onClick={() => setShowType('3d')}
        >分子空间结构</li>
        <li className={`${showType === '2d' ? 'active' : ''}`}
          onClick={() => setShowType('2d')}
        >分子图</li>
        {/* <li><FullscreenOutlined /></li> */}
      </ul>
    )
  }


  const showLengedList = () => {
    if (numeratorInfo) {
      const { infos } = numeratorInfo;
      if (showType === '2d') {
        return ''
      } else {
        return (
          <ul className='lengedList'>
            {Object.keys(infos).map((item: any) => {
              return (
                <li key={item}>
                  <span
                    className='lenged'
                    style={{
                      backgroundImage: `radial-gradient(${elementsList[item].colors[0]}, rgba(0,0,0,.5))`,
                    }}
                  ></span>
                  {infos[item].name} ({item})-
                  <span className='red'>({infos[item].total})</span>
                </li>
              );
            })}
          </ul>
        );
      }

    } else {
      return '';
    }
  };

  const colorMod2 = (fa: any) => {
    let c = 'red';
    const { atom } = fa;
    // console.log(atom);
    return elementsList[atom].colors[0] ? elementsList[atom].colors[0] : c;
  };

  const show3dModel = (file: any, rid: any) => {
    // console.log(file);
    fetch(file)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        // const fs = file.substring(file.lastIndexOf("/") + 1).split('.');
        // let element = $('#d' + Md5.init(filePath + rid));
        let element = $('#d' + rid);
        let config = { backgroundColor: 'rgba(0,0,0,1)', backgroundAlpha: 0 };
        let viewer = $3Dmol.createViewer(element, config);
        if (!viewer) return;
        viewer.clear();
        viewer.addModel(data, '.sdf'); /* load data */
        setAllAtomInfos(
          setNumeratorInfo(
            getallAtomsCate(viewer.getModel().getInternalState().atoms)
          )
        );
        if (setAtomsInfos) {
          setAtomsInfos(viewer.getModel().getInternalState().atoms);
        }
        viewer.setStyle(
          {},
          {
            stick: { 
              
            //   material: {
            //     ambient: 0x333333,  // 环境光颜色
            //     diffuse: 0x999999,  // 漫反射颜色
            //     specular: 0xffffff, // 镜面反射颜色
            //     shininess: 30       // 光泽度
            // },
              // color: '#BABABA', 
              radius: 0.13
             },
            sphere: { 


              // colorscheme: "ssPyMol",
              colorfunc: colorMod2,
              //  radius: 0.3,
              scale: 0.3,
              ambient: 1, specular: 0.8
               },
          }
        );
        /* style all atoms */
        viewer.setClickable(
          {},
          true,
          (atom: any, viewer: any, event: any, container: any) => {
            // v.removeAllLabels();

            const cu = elementsList[atom.atom];

            setCurElementInfo({
              ...cu,
              x: atom.x,
              y: atom.y,
              z: atom.z,
            });

            // setCurElementInfo(elementsList[atom.atom])
            setElementInfoStatus(true);
            // viewer.addLabel(s + '：' + atom.serial, {
            //   position: atom,
            //   backgroundColor: 'dark',
            //   backgroundOpacity: 0.8,
            // });
            // v.setStyle({}, { stick: { radius: 0.2 }, sphere: { radius: 0.5 } });
          }
        );
        viewer.setHoverable(
          {},
          true,
          (atom: any, vie: any, event: any, container: any) => {
            if (!atom.label) {
              const s = elementsList[atom.atom].cname;
              // if (atom.atom === 'H') {
              //   s = '氢';
              // } else if (atom.atom === 'N') {
              //   s = '氮';
              // } else if (atom.atom === 'R') {
              //   s = '未知元素';
              // } else {
              //   s = '碳';
              // }
              atom.label = vie.addLabel(
                s +
                ' x:' +
                Number(atom.x.toFixed(4)) +
                ' y:' +
                Number(atom.y.toFixed(4)) +
                ' z:' +
                Number(atom.z.toFixed(4)),
                {
                  position: atom,
                  backgroundColor: 'mintcream',
                  fontColor: 'black',
                }
              );
            }
          },
          function (atom: any) {
            if (atom.label) {
              viewer.removeLabel(atom.label);
              delete atom.label;
            }
          }
        );

        // viewer.setLightParameters({
        //   ambient: 0.8,    // 环境光强度（影响整体亮度）
        //   diffuse: 0.6,    // 漫反射强度
        //   specular: 0.4    // 镜面反射强度
        // });
        // glviewer.setStyle({}, { stick: { radius: 0.3 }, sphere: { radius: 0.5 } });
        viewer.zoomTo(); /* set camera */
        viewer.render(); /* render scene */
        // console.log(viewer.getModel().getInternalState());
        // console.log(viewer.getModel().getNumFrames(0));
        viewer.zoom(1.8, 0); /* slight zoom */

        // setTimeout(()=>{

        // }, 1000 )
      });
  };

  useEffect(() => {
    let rid = 'modelViewer';
    if(refresh){
      rid = Md5.init(filePath + randomId());
    }
    $('#d' +rid).html('');
    show3dModel(filePath, rid);
    setrandomIds(rid);
    
    // return () => { };
  }, [filePath]);

  // const items = [
  //   {
  //     label: <b>3d</b>,
  //     key: '3d',
  //     children: (
  //       <div className={`${classTag}`}>
  //         <div
  //           id={`d${Md5.init(filePath + randomIds)}`}
  //           className={`modelArea`}
  //           style={{ width: `${width}`, height: `${height}` }}
  //         />
  //         {disLenged ? '' : showLengedList()}
  //         {showControlBar()}
  //       </div>
  //     ),
  //   },
  //   {
  //     label: <b>2d</b>,
  //     key: '2d',
  //     children: (
  //       <div style={{ textAlign: 'center' }}>
  //         <Image src={pngImg} />
  //       </div>
  //     ),
  //   },
  // ];

  // const onChangeTab = (key: any) => {
  //   setShowType(key);
  // };


  return (
    <>
      {/* {pngImg ? (
        <Tabs
          onChange={onChangeTab}
          type='card'
          defaultActiveKey={showType}
          // tabPosition='left'
          items={items}
        />
      ) : ( */}
      <div className='showObjArea'>
        {pngImg ?
          <>
            <div className='molBg1' style={{backgroundColor:`${bgColor ? bgColor :''}`}}>
              <div
                id={`d${randomIds}`}
                // className={`modelArea`}
                style={{ width: `${width}`, height: `${height}`, display: `${showType === '3d' ? 'block' : 'none'}` }}
              />
              {disLenged ? '' : showLengedList()}
            </div>
            <div style={{ textAlign: 'center', display: `${showType === '3d' ? 'none' : 'block'}` }}>
              <Image src={pngImg} height={`${height}`} />
            </div>
            {showControlBar()}
          </>
          :
          <div className='molBg1' style={{backgroundColor:`${bgColor ? bgColor :''}`}}>
            <div
              id={`d${randomIds}`}
              className={`modelArea`}
              style={{ width: `${width}`, height: `${height}` }}
            />
            {disLenged ? '' : showLengedList()}
          </div>
        }
      </div>
      {/* )} */}
      <ElementInfo
        status={elementInfoStatus}
        setStatus={(b: boolean) => setElementInfoStatus(b)}
        curInfo={curElementInfo}
      />
    </>
  );
};

export default Component;
